import React, { Component } from 'react';
import MultiSelect from './MultiSelect.js';
import { withStyles } from '@material-ui/core/styles';
import { components } from 'react-select';
import { withTranslation } from 'react-i18next';

class Select extends Component {
  render() {
    const { classes, t } = this.props;

    const Option = (props) => {
      return (
        <div>
          <components.Option {...props}>
            <input type='checkbox' checked={props.isSelected} onChange={() => null} /> <label>{t(props.label)}</label>
          </components.Option>
        </div>
      );
    };

    const ValueContainer = ({ children, ...props }) => {
      const currentValues = props.getValue();
      let toBeRendered = children;
      if (currentValues.some((val) => val.value === this.props.allOption.value)) {
        toBeRendered = [[children[0][0]], children[1]];
      }

      return <components.ValueContainer {...props}>{toBeRendered}</components.ValueContainer>;
    };

    const MultiValue = (props) => {
      let labelToBeDisplayed = `${props.data.label}`;
      if (props.data.value === this.props.allOption.value) {
        labelToBeDisplayed = `${t(props.data.label)}`;
      }
      return (
        <components.MultiValue {...props}>
          <span>{labelToBeDisplayed}</span>
        </components.MultiValue>
      );
    };

    return (
      <div style={{ display: 'flex', width: '100%' }}>
        <div className={`${classes.root}`}>
          <MultiSelect
            id={this.props.id}
            allOption={this.props.allOption}
            options={this.props.options}
            isMulti
            closeMenuOnSelect={false}
            hideSelectedOptions={false}
            components={{
              Option,
              MultiValue,
              ValueContainer,
            }}
            onChange={this.props.handleSelectModules}
            allowSelectAll={true}
            value={this.props.valueData}
            isDisabled={this.props.disabled}
            styles={selectStyles}
          />
        </div>
      </div>
    );
  }
}

const selectStyles = {
  menuList: (provided, state) => ({
    ...provided,
    maxHeight: '150px',
  }),
};

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    marginTop: 5,
  },
  input: {
    display: 'flex',
    padding: 0,
    backgroundColor: 'white',
  },
  valueContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    flex: 1,
    alignItems: 'center',
    overflow: 'hidden',
    position: 'relative',
  },
  noOptionsMessage: {
    padding: `${theme.spacing.unit}px ${theme.spacing.unit * 2}px`,
  },
  singleValue: {
    fontSize: 16,
  },
  placeholder: {
    position: 'absolute',
    left: 20,
    fontSize: 16,
  },
  paper: {
    position: 'absolute',
    width: '100%',
    zIndex: 1,
    // marginTop: theme.spacing.unit,
    // left: 0,
    // right: 0,
    // maxHeight: "250px",
  },
  divider: {
    height: theme.spacing.unit * 2,
  },
  iconButton: {
    marginLeft: 8,
    height: '36px',
  },
});

export const translation = withTranslation()(Select);
export default withStyles(styles, { withTheme: true })(translation);
